import { createListCollection } from "@chakra-ui/react";
import { Select } from "./Select";

interface LanguageOption {
  value: string;
  label: string;
}

interface LanguageSelectorProps {
  defaultValue?: string;
  size?: "sm" | "md" | "lg";
  maxW?: string;
  languages?: LanguageOption[];
}

const defaultLanguages: LanguageOption[] = [{ value: "en", label: "EN" }];

export default function LanguageSelector({
  defaultValue = "en",
  size = "sm",
  maxW = "100px",
  languages = defaultLanguages,
}: LanguageSelectorProps) {
  const languageCollection = createListCollection({
    items: languages,
  });

  return (
    <Select
      collection={languageCollection}
      defaultValue={[defaultValue]}
      rootProps={{ size, w: "auto", maxW }}
    />
  );
}
